import type { BankItem } from 'entities/vitrins';

// заполняем summary до одинакового кол-ва элементов, если кол-во передано
export const padSummaryToCount = (
  offer: BankItem,
  minSummaryItemsCount?: number,
  isMobile?: boolean,
): BankItem['summary'] => {
  if (isMobile || !minSummaryItemsCount) {
    return offer.summary;
  }

  const emptyItemsCount = minSummaryItemsCount - offer.summary.length;

  if (emptyItemsCount <= 0) {
    return offer.summary;
  }

  const emptySummaryItems = Array.from({ length: emptyItemsCount }, () => ({
    label: '',
    value: '',
  }));

  return [...offer.summary, ...emptySummaryItems];
};
